module.exports = __webpack_public_path__ + "static/img/logo.48ccecf.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/logo.png
// module id = 6PsS
// module chunks = 12